<div class="textarea-container">
  <label *ngIf="label" class="textarea-label">{{ label }}</label>

  <textarea
    [rows]="rows"
    [placeholder]="placeholder"
    [value]="value"
    (input)="handleInput($event)"
    (blur)="onTouched()"
    [attr.maxlength]="maxLength"
  ></textarea>

  <div class="char-count" *ngIf="maxLength">
    {{ value.length }}/{{ maxLength }}
  </div>
</div>
